module.exports = __webpack_public_path__ + "static/fish-4f49e11d016dee1459e08c1b4c2cbbda.ogv";